<template>
  <div v-if="serverdate && !loading">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="text-container">
        <div class="title-area">
          <h1 class="page-title">
              <span
                :class="`${anon ? 'g-anon' : '' }`"
              >
                {{ survey_name }}:
              </span>
              {{ screentexts[50]?screentexts[50].element_text:'Set Survey Dates' }}
              <!-- <PopupBubble
                v-if="screentexts[50] && screentexts[50].element_bubbletext != '' && screentexts[50].element_bubbletext !== null"
                screenelement_id="50"
                :screen_id="screen_id"
                :bubbletext="screentexts[50]?screentexts[50].element_bubbletext:''"
              /> -->
          </h1>
        </div>
        <h4 class="text-md">{{ screentexts[51]?screentexts[51].element_text:'When would you like to launch the survey?' }}</h4>
        <b-form-group class="">
          <b-form-radio
            v-model="selected"
            name="send_date"
            value="A"
          >
            {{ screentexts[52]?screentexts[52].element_text:'Right Now' }}
          </b-form-radio>
          <b-form-radio
            v-model="selected"
            name="send_date"
            value="B"
          >
            {{ screentexts[53]?screentexts[53].element_text:'At a particular date and time (CET)' }},
            <br><br>Current date and time CET: {{ serverdate && serverdate.substring(0,10) }} {{ serverdate && serverdate.substring(11,16) }}
          </b-form-radio>
        </b-form-group>
        <div
          v-show="selected === 'B'"
        >
          <b-form
            @submit.stop.prevent
          >
            <b-form-group
              :label="`${screentexts[58]?screentexts[58].element_text:'Date'} (CET)`"
            >
              <datetime
                id="start_date"
                v-model="start_date"
                type="date"
                input-class="form-control"
                format="yyyy-LL-dd"
                :min-datetime="new Date(start_date).toISOString()"
                :value="new Date(start_date).toISOString()"
                :value-zone="timeZone"
                :zone="timeZone"
                @input="checkstartdate"
                :phrases="{ok: screentexts[60]?screentexts[60].element_text:'OK', cancel: screentexts[61]?screentexts[61].element_text:'Cancel'}"
              />
            </b-form-group>
            <b-form-group
              :label="`${screentexts[59]?screentexts[59].element_text:'Time'} (CET)`"
              >
              <datetime
                id="start_time"
                v-model="start_time"
                type="time"
                :value="start_time"
                :value-zone="timeZone"
                :minute-step="5"
                input-class="form-control"
                :phrases="{ok: screentexts[60]?screentexts[60].element_text:'OK', cancel: screentexts[61]?screentexts[61].element_text:'Cancel'}"
                :title="screentexts[62]?screentexts[62].element_text:'Select sending time'"
                @input="checkstartdate"
                :zone="timeZone"
              />
              <span class="text-danger" v-show="showtimeadjust">The selected date and time has already past, the invitations will be sent out within 5 minutes after finishing the set-up.</span>
            </b-form-group>
          </b-form>
        </div>
        <h4 class="text-md">{{ screentexts[54]?screentexts[54].element_text:'When is the last day your participants can respond to this survey?' }}</h4>
        <b-form-group
          class=""
          label=""
          :description="screentexts[55]?screentexts[55].element_text:'The report will only take a few seconds for our system to calculate, but we recommend that you pull your report a few days in advance so you can prepare for your presentation'"
        >
          <b-form
            @submit.stop.prevent
          >
            <b-form-group
              :label="screentexts[58]?screentexts[58].element_text:'Date'"
              >
                <datetime
                  id="end_date"
                  v-model="end_date"
                  type="date"
                  input-class="form-control"
                  format="yyyy-LL-dd"
                  :min-datetime="new Date(serverdate).toISOString()"
                  :value="end_date"
                  :value-zone="timeZone"
                  :phrases="{ok: screentexts[60]?screentexts[60].element_text:'OK', cancel: screentexts[61]?screentexts[61].element_text:'Cancel'}"
                  :zone="timeZone"
                />
            </b-form-group>
          </b-form>
        </b-form-group>
        <div v-if="canremind">
          <h4 class="text-md">
            <span
              v-html="screentexts[56]?screentexts[56].element_text:'Would you like to schedule a reminder to help keep an eye on how your data collection is going and perhaps remind your participants to take part?'"
            />
          </h4>
          <div class="">
            <b-form-group label="">
              <b-form-checkbox
                v-model="reminder"
                value="1"
                unchecked-value="0"
              >
                {{ screentexts[63]?screentexts[63].element_text:'Yes' }}
              </b-form-checkbox>
            </b-form-group>
            <div v-show="reminder === '1'">
              <b-form-group
                :state="reminder_email_valid"
                :label="screentexts[65]?screentexts[65].element_text:'Send reminder to this e-mail'"
                :description="screentexts[65]?screentexts[65].element_bubbletext:'Leave this field blank if you do not want a reminder e-mail'"
              >
                <b-form-input
                  :class="`${anon ? 'g-anon' : '' }`"
                  v-model="reminder_email"
                  :state="reminder_email_valid"
                />
                <b-form-invalid-feedback id="reminder_email-feedback">
                  {{ screentexts[66]?screentexts[66].element_text:'Invalid e-mail address' }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group :label="screentexts[67]?screentexts[67].element_text:'On this date:'">
                <form
                  @submit.stop.prevent
                >
                  <datetime
                    id="reminder_date"
                    v-model="reminder_date"
                    inline
                    type="date"
                    input-class="form-control"
                    format="yyyy-LL-dd"
                    :min-datetime="new Date(reminder_date_min).toISOString()"
                    :value="reminder_date"
                    :value-zone="timeZone"
                    :zone="timeZone"
                    :phrases="{ok: screentexts[60]?screentexts[60].element_text:'OK', cancel: screentexts[61]?screentexts[61].element_text:'Cancel'}"
                  />
                </form>
              </b-form-group>
            </div>
          </div>
        </div>

        <h4 class="text-md">{{ screentexts[57]?screentexts[57].element_text:'Would you like to send out an automatic reminder email to all of your participants to answer the questionnaire 3 days before the last day?' }}</h4>
        <b-form-group class="">
          <b-form-radio
            v-model="remindparticipants"
            name="remindparticipants_action"
            value="1"
          >
            {{ screentexts[63]?screentexts[63].element_text:'Yes' }}
          </b-form-radio>
          <b-form-radio
            v-model="remindparticipants"
            name="remindparticipants_action"
            value="0"
          >
            {{ screentexts[64]?screentexts[64].element_text:'No' }}
          </b-form-radio>
        </b-form-group>
        <div class="buttons-navigation">
          <b-link
            v-if="has_online==1"
            to="/create/group/survey/emailsettings"
            class="float-left"
          >
            <b-button variant="secondary">
              &lt; {{ screentexts[68]?screentexts[68].element_text:'Back' }}
            </b-button>
          </b-link>
          <b-link
            v-if="has_online==0"
            to="/create/group/survey/details"
            class="float-left"
          >
            <b-button variant="secondary">
              &lt; {{ screentexts[68]?screentexts[68].element_text:'Back' }}
            </b-button>
          </b-link>
          <b-link
            to="/create/group/survey/launch"
            class="float-right"
          >
            <b-button variant="primary">
              {{ screentexts[69]?screentexts[69].element_text:'Next' }} &gt;
            </b-button>
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { config } from '../../config'
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import { Datetime } from 'vue-datetime'

export default {
  name: 'CreateGroupSurveyDates',
  components: {
    Navbar,
    Breadcrumb,
    Datetime
    // PopupBubble,
  },
  data () {
    return {
      serverdate: null,
      timeZone: config.timeZone,
      showtimeadjust: false,
      group_name: this.$store.state.currentgroup.group_name,
      survey_name: this.$store.state.currentsurvey.survey_name,
      reminder: 0,
      reminder_mobile: '',
      remindparticipants: 0,
      selected: 'A',
      start_date: this.default_start_date(),
      start_time: null,
      end_date: null,
      reminder_date: this.default_reminder_date(),
      reminder_time: new Date().toLocaleString('sv-SE', { timeZone: config.timeZone }),
      reminder_email: this.$store.state.user.email,
      reminder_email_valid: null,
      has_online: 0,
      has_paper: 0,
      screen_id: 8,
      screentexts: [],
      loading: true,
      suppressSelectedWatcher: false
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    survey_id: {
      get () {
        return this.$store.state.currentsurvey.id
      },
      set () {
        return true
      }
    },
    start_date_min: {
      get () {
        return new Date(this.serverdate).toISOString()
      },
      set () {
        return true
      }
    },
    start_time_min: {
      get () {
        return '00:00'
      },
      set () {
        return true
      }
    },
    reminder_date_min: {
      get () {
        let newvalue = new Date(this.start_date)
        newvalue.setDate(newvalue.getDate() + 1)
        return newvalue
      },
      set () {
        return true
      }
    },
    canremind: {
      get () {
        const nowvalue = new Date(this.serverdate)
        const endvalue = new Date(this.end_date)
        return endvalue > nowvalue
      },
      set () {
        return true
      }
    }
  },
  watch: {
    selected: function () {
      if (this.suppressSelectedWatcher) {
        return
      }
      var date = new Date(this.serverdate)
      if (this.selected === 'B') {
        date.setDate(date.getDate() + 1)
      }
      this.start_date = new Date(date).toISOString()
      this.start_time = new Date(date).toISOString()
    },
    serverdate: function () {
      if (this.start_time === null) {
        this.start_time = new Date(this.serverdate).toISOString()
      }
    },
    start_date: function (newval, oldval) {
      console.log('Start date changed from ' + oldval + ' to ' + newval)
    }
  },
  async created () {
    this.loading = true
    await this.screentexts_get()
    await this.cetdate_get()
    await this.survey_get()
    this.applySurveySettingsFromStore()
    if (!this.end_date) {
      this.end_date = this.default_end_date()
    }
    this.loading = false
  },
  async beforeRouteLeave (to, from, next) {
    // ----------------------------
    // We are going forward - save
    // ----------------------------
    if (to.name == 'creategroupsurveylaunch') {
      if (this.validateform()) {
        await this.groupsurvey_save()
        next()
      }
    } else {
      next()
    }
  },
  methods: {
    applySurveySettingsFromStore () {
      const survey = this.$store.state.currentsurvey || {}
      if (survey.survey_start_date && survey.survey_start_date > '2000-01-01') {
        const startDateObj = this.toDateObject(survey.survey_start_date, survey.survey_start_time)
        const now = new Date()
        this.selected = startDateObj > now ? 'B' : 'A'
        if (this.selected === 'B') {
          this.suppressSelectedWatcher = true
          const iso = startDateObj.toISOString()
          this.start_date = iso
          this.start_time = iso
          this.$nextTick(() => { this.suppressSelectedWatcher = false })
        } else if (this.serverdate) {
          this.start_date = new Date(this.serverdate).toISOString()
          this.start_time = new Date(this.serverdate).toISOString()
        }
      }

      if (survey.survey_end_date && survey.survey_end_date > '2000-01-01') {
        this.end_date = this.toDateObject(survey.survey_end_date).toISOString()
      }

      if (survey.survey_reminder_date && survey.survey_reminder_date > '2000-01-01') {
        this.reminder_date = this.toDateObject(survey.survey_reminder_date).toISOString()
      }

      if (survey.survey_reminder_email) {
        this.reminder_email = survey.survey_reminder_email
      }
      this.reminder = (survey.survey_reminder === 1 || survey.survey_reminder === '1') ? '1' : '0'
      const rp = survey.survey_remindparticipants
      this.remindparticipants = rp === undefined || rp === null ? '0' : String(rp)
    },
    // cetdate_toISOString(date) {
    //   console.log('cetdate_toISOString', new Date(date.toLocaleString('sv-SE', { timeZone: this.timeZone })).toISOString())
    //   const cetdateIso = new Date(date.toLocaleString('sv-SE', { timeZone: this.timeZone })).toISOString()
    //   return cetdateIso
    // },
    cetdate_get: async function () {
      await this.$store.dispatch('serverdate_fetch')
        .then((resp) => {
          const date = resp.data
          this.serverdate = date
          return this.serverdate
        })
    },
    checkstartdate (event) {
      if (this.loading == true) { return true }
      this.showtimeadjust = false
      const startvalue =
        this.start_date.substring(0, 10) +
        'T' +
        this.start_time.substring(this.start_time.indexOf('T') + 1)
      const startvaluetz = new Date(this.serverdate)
      const nowdate = this.serverdate
      if (startvaluetz < nowdate) {
        this.showtimeadjust = true
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    screentexts_get: async function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    validateform () {
      var formok = true
      this.reminder_email_valid = null
      // Online form
      if (this.reminder == 1) {
        // eslint-disable-next-line
        if (!this.parse_email(this.reminder_email)) {
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.reminder_email) == false) {
          this.reminder_email_valid = 'invalid'
          formok = false
        }
        if (this.reminder_email == '') {
          this.reminder_email_valid = 'invalid'
          formok = false
        }
      }
      return formok
    },
    async groupsurvey_save () {
      var survey = {
        id: this.$store.state.currentsurvey_id,
        survey_name: this.$store.state.currentsurvey.survey_name,
        survey_language_id: this.$store.state.currentsurvey.survey_language_id,
        survey_normvalues_id: this.$store.state.currentsurvey.survey_normvalues_id,
        survey_type_id: this.$store.state.currentsurvey.survey_type_id,
        survey_invoice_reference: this.$store.state.currentsurvey.survey_invoice_reference,
        survey_start_date: this.format_date(this.start_date),
        survey_start_time: (this.start_time != null) ? this.format_time(this.start_time) : '00:00',
        survey_end_date: this.format_date(this.end_date),
        survey_reminder_date: this.format_date(this.reminder_date),
        survey_reminder_time: (this.reminder_time != null) ? this.format_time(this.reminder_time) : '00:00',
        survey_reminder_email: this.reminder_email,
        survey_reminder_mobile: this.reminder_mobile,
        survey_reminder: Number(this.reminder),
        survey_remindparticipants: Number(this.remindparticipants)
      }
      await this.$store.dispatch('groupsurvey_save', { survey: survey })
    },
    survey_get: async function () {
      await this.$store.dispatch('groupsurvey_fetch', { id: this.$store.state.currentsurvey_id })
        .then((resp) => {
          var members = this.$store.state.currentsurveymembers
          var start_date = new Date(this.$store.state.currentsurvey.survey_start_date)
          var today = new Date()
          if (start_date > today) {
            this.selected = 'B'
          }
          for (var i = 0; i < members.length; i++) {
            if (members[i].groupsurveymember_formoption_id == 1) { this.has_online = 1 }
            if (members[i].groupsurveymember_formoption_id == 2) { this.has_paper = 1 }
          }
        })
    },
    format_date (date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    format_time (date) {
      const tzdate = new Date(date).toLocaleString('sv-SE', { timeZone: config.timeZone })
      const ret = tzdate.split(' ')[1].substring(0, 5)
      return ret
      // var d = new Date(date)
      // var h = d.getHours()
      // var m = d.getMinutes()
      // var hour = (h > 9 ? '' : '0') + h
      // var minute = (m > 9 ? '' : '0') + m
      // var thistime = hour + ':' + minute
      // return thistime
    },
    default_end_date () {
      var date = new Date()
      date = this.add_months(date, 3)
      return date.toISOString()
    },
    default_start_date () {
      var date = new Date()
      return date.toISOString()
    },
    default_reminder_date () {
      var date = new Date()
      date.setDate(date.getDate() + 87)
      return date.toISOString()
    },
    add_months (date, count) {
      if (date && count) {
        var m; var d = (date = new Date(+date)).getDate()
        date.setMonth(date.getMonth() + count, 1)
        m = date.getMonth()
        date.setDate(d)
        if (date.getMonth() !== m) date.setDate(0)
      }
      return date
    },
    toDateObject (dateString, timeString = '00:00') {
      return new Date(dateString + 'T' + (timeString || '00:00'))
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
